﻿const PRODUCTION = 'PRODUCTION';
const TESTING = 'TESTING';

export const Environment = TESTING;      //    PRODUCTION

export const AppVersion = 'V. 0.0.1.00';

export const isProdEnv = () => Environment === PRODUCTION;
export const baseURL = isProdEnv() ? "https://api.greensunmedical.com" : "https://api-dev.greensunmedical.com"
